import React, { useState, useContext, useEffect } from 'react';
import PropTypes from 'prop-types';
import { message, Spin, Modal, Button, notification } from 'antd';
import './styles.less';
import { useForm } from 'antd/es/form/Form';
import InvestorSurvey from '../../../../../EnrollmentPage/components/steps/InvestorProfileStep/InvestorSurvey';
import InvestorLegalSurveyResult from './InvestorLegalSurveyResult';
import { EnrollmentContext } from '../../../../../../providers/EnrollmentContextProvider';
import enrollmentAction from '../../../../../../providers/EnrollmentContextProvider/enrollmentAction';
import useParams from '../../../../../params/useParams';
import paramType from '../../../../../params/paramEndpoints';
import EnrollmentService from '../../../../../EnrollmentPage/EnrollmentService';
import LegalProfile from './LegalProfile';

import { EnrollmentFormContext } from '../../../../../../providers/EnrollmentFormContextProvider';

function info2() {
  Modal.info({
    title: 'Contratación de productos no acorde con perfil de riesgo',
    okText: 'Entiendo',
    closable: true,
    width: 700,
    style: { top: 20 },
    cancelText: 'cancelar',
    content: (
      <div>
        <p>
          El cliente declara y manifiesta lo siguiente:
          <br />
          Que conforme su perfil de riesgo, los productos indicados en Corredora de Bolsa S.A no son
          acordes a su perfil de inversionista. Que Grupo Vantrust Capital S.A le ha advertido
          expresamente de la circunstancia anterior y de los riesgos que conllevan invertir en los
          productos indicados y que, por tanto, se le ha aconsejado expresamente desistirse de
          invertir en ellos. Que no obstante lo anterior, libre y espontáneamente manifiesta a Grupo
          Vantrust Capital S.A su intención de contratar los productos indicados, asumiendo todos
          los riesgos que de ello deriven.
        </p>
      </div>
    ),
    onOk() {},
    onCancel() {},
  });
}

const openNotification = () => {
  const key = `open${Date.now()}`;
  const btn = (
    <Button
      type="primary"
      size="small"
      onClick={() => {
        notification.close(key);
        info2();
      }}
    >
      Entendido
    </Button>
  );
  notification.info({
    message: 'Producto no acorde con perfil de riesgo',
    description:
      ' El producto seleccionado no es acorde a su perfil de inversionista. Para contratarlo se le solicitará declarar los riesgos de inversión.',
    btn,
    key,
    // onClose: close,
    onOk() {},
  });
};

const InvestorProfile = ({ onFinish }) => {
  const [isLoading, setLoading] = useState(false);
  const [currentQuestionIndex, setCurrentQuestionIndex] = useState(0);
  const [answers, setAnswers] = useState([]);
  const [ShowSurvey, setShowSurvey] = useState(false);

  const [questions, areQuestionsLoading] = useParams(paramType.INVESTOR_PROFILE_QUESTIONS);

  const [investorVehiclesProducts, isLoadingInvestorVehiclesProducts] = useParams(
    paramType.INVESTOR_VEHICLE_PRODUCTS
  );

  const [profiles] = useParams(paramType.INVESTOR_PROFILES);
  const [products] = useParams(paramType.VEHICLES);

  const { dispatch, enrollmentId } = useContext(EnrollmentContext);
  const { enrollmentForm } = useContext(EnrollmentFormContext);
  const [profileForm] = useForm();
  const [investorProfile, setInvestorProfile] = useState(
    enrollmentForm.getFieldValue(['investorProfile'])
  );
  const [selectedProductId, setSelectedProductId] = useState(
    enrollmentForm.getFieldValue(['products'])
  );

  const currentQuestion = questions[currentQuestionIndex];

  useEffect(() => {
    if (questions.length > 0 && questions.length !== answers.length) {
      setAnswers(new Array(questions.length));
    }
  }, [questions, setAnswers, answers]);

  const goToPreviousQuestion = () => {
    // TODO: Refactor this (maybe)
    if (currentQuestionIndex === 0) {
      setSelectedProductId(undefined);
    }
    setCurrentQuestionIndex(Math.max(currentQuestionIndex - 1, 0));
  };

  const goToNextQuestion = () => {
    setCurrentQuestionIndex(Math.min(currentQuestionIndex + 1, questions.length - 1));
  };

  const HandleSurvey = () => {
    setShowSurvey(true, selectedProductId);
  };

  const validateProfile = (value, swFunction = true) => {
    const profileVehicles = investorVehiclesProducts.find(
      (element) => element.id === investorProfile.id
    );

    const ProductVehicle = profileVehicles.products.find((element) => element.productId === value);
    if (swFunction) {
      if (!ProductVehicle) openNotification();
    }
    return ProductVehicle !== undefined;
  };

  const restartSurvey = () => {
    profileForm.resetFields();
    setAnswers(new Array(questions.length));
    setCurrentQuestionIndex(0);
    setInvestorProfile(null);
    dispatch({ type: enrollmentAction.EXPAND_STEP });
    dispatch({
      type: enrollmentAction.SET_PARTIAL_STEP_DATA,
      payload: {
        investorProfile: undefined,
      },
    });
  };

  const handleAnswer = (newAnswer) => {
    const updatedAnswers = [...answers];
    updatedAnswers[currentQuestionIndex] = newAnswer;
    setAnswers(updatedAnswers);

    const isSurveyFinished = currentQuestionIndex === questions.length - 1;

    if (isSurveyFinished) {
      const finalScore = updatedAnswers
        .map((answer) => answer.score)
        .reduce((accumulated, currentValue) => accumulated + currentValue);

      const chosenInvestorProfile = profiles.find(
        (profile) => finalScore >= profile.minScore && finalScore <= profile.maxScore
      );

      if (chosenInvestorProfile) {
        setInvestorProfile(chosenInvestorProfile);
        dispatch({ type: enrollmentAction.SHRINK_STEP });
        dispatch({
          type: enrollmentAction.SET_STEP_DATA,
          payload: {
            investorProfile: chosenInvestorProfile,
          },
        });
      }

      setLoading(true);

      const payload = {
        investorProfileAnswers: updatedAnswers.map((answer, index) => ({
          questionId: index + 1,
          answerId: answer.id,
        })),
        investorProfileId: chosenInvestorProfile?.id,
      };

      EnrollmentService.updateEnrollment(payload, enrollmentId)
        .catch(() => {
          message.error('Error inesperado. Por favor, intente nuevamente.');
          setCurrentQuestionIndex(currentQuestionIndex - 1);
        })
        .finally(() => {
          setLoading(false);
        });

      return;
    }

    goToNextQuestion();
  };

  const handleSubmit = (values) => {
    setLoading(true);

    dispatch({ type: enrollmentAction.SET_PARTIAL_STEP_DATA, payload: values });

    const payload = {
      products: values.products,
      // investorProfile: {
      //   hasMoreThan1000InActives: values.isQualifiedInvestor && !!values.hasMoreThan1000InActives,
      //   hasMoreThan1000InTransactions:
      //     values.isQualifiedInvestor && !!values.hasMoreThan1000InTransactions,
      //   hasRelatedStudies: values.isQualifiedInvestor && !!values.hasRelatedStudies,
      //   hasRiskKnowledge: values.isQualifiedInvestor && !!values.hasRiskKnowledge,
      //   hasTwoYearsExperience: values.isQualifiedInvestor && !!values.hasTwoYearsExperience,
      //   isQualifiedInvestor: !!values.isQualifiedInvestor,
      // },
    };

    EnrollmentService.updateEnrollment(payload, enrollmentId)
      .then(({ data }) => {
        dispatch({ type: enrollmentAction.SET_ENROLLMENT, payload: data });
        onFinish();
      })
      .catch(() => {
        message.error('Error inesperado. Por favor, intente nuevamente.');
      })
      .finally(() => {
        setLoading(false);
      });
  };

  if (investorProfile)
    return (
      <Spin spinning={isLoadingInvestorVehiclesProducts || isLoading}>
        <InvestorLegalSurveyResult
          profileForm={profileForm}
          onRestartClick={restartSurvey}
          investorProfile={investorProfile}
          onFinish={handleSubmit}
          validateProfile={validateProfile}
          productos={products}
        />
      </Spin>
    );

  if (!ShowSurvey) {
    return (
      <Spin spinning={isLoading}>
        <LegalProfile HandleSurvey={HandleSurvey} />
      </Spin>
    );
  }

  return (
    <Spin spinning={areQuestionsLoading || isLoading}>
      {questions.length > 0 && (
        <InvestorSurvey
          profileForm={profileForm}
          currentQuestion={currentQuestion}
          currentQuestionIndex={currentQuestionIndex}
          onPreviousQuestionClick={goToPreviousQuestion}
          onAnswer={handleAnswer}
        />
      )}
    </Spin>
  );
};

InvestorProfile.propTypes = {
  onFinish: PropTypes.func.isRequired,
};

export default InvestorProfile;
